import api from '../../api';
import config from '../../config';
// const { DOMAIN_KEY } = process.env;
export default {
    get: (userId) => {
        return api.request('get',config.default.jobDetaills+'/?userId='+userId+'&$sort[createdAt]=-1', null, null, null)
    },
    post: (data, headers) => {
        return api.request('post',config.default.jobDetaills, headers, null, data)
    },
    patch: (id, headers, data = null) => {
        return api.request('patch', config.default.jobDetaills+'/'+id, headers, null, data)
    }
}